/**
 * 開閉できる節。深掘りの情報を、件数つきの見出しだけを見せて閉じた節に畳む（Dhik 2026-09-29
 * 「本当に出すべき情報を 1 or 2 個に」）。マスター詳細の「ほかの欄」「鎖の前後」と、用語詳細の
 * 「揺れ表記」が使う。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 詳細画面の深掘りの情報を、件数つきの見出しだけを見せた閉じた節に畳む。
 * @graph-connects none
 */
import type { ReactNode } from 'react';

/** `FoldedSection` の props。 @graph-connects none */
export interface FoldedSectionProps {
  /** 節の識別子（`data-folded`）。 */
  name: string;
  /** 見出し。 */
  title: string;
  /** 見出しの横に添える件数。省けば出さない。 */
  count?: number;
  /** 開いたときに出す中身。 */
  children: ReactNode;
}

/**
 * 開閉できる節を描く。既定は閉じる。
 *
 * @param props 識別子 ・ 見出し ・ 件数 ・ 中身
 * @returns 閉じた節
 * @graph-node {Function}
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 深掘りの情報を、件数つきの見出しだけを見せて閉じた節に畳む。
 * @graph-connects none
 */
export function FoldedSection({ name, title, count, children }: FoldedSectionProps) {
  return (
    <details data-folded={name} className="border-t border-[var(--color-border)] pt-2">
      <summary className="cursor-pointer text-xs font-bold text-[var(--color-text-muted)]">
        {title}
        {count !== undefined && <span className="ml-1 font-normal">{count}</span>}
      </summary>
      <div className="mt-2">{children}</div>
    </details>
  );
}
